module.exports = __webpack_public_path__ + "media/images/icons/twotone/ci-b6684327017382aab377391e8b0c0d8b.svg";